import { useState } from 'react';
import { ThemeProvider, CssBaseline, Box, Snackbar, Alert } from '@mui/material';
import theme, { GOLD } from './theme/theme';

import Navbar        from './components/Navbar';
import HeroSlider    from './components/HeroSlider';
import CityBoxes     from './components/CityBoxes';
import TrustBadges   from './components/TrustBadges';
import Testimonials  from './components/Testimonials';
import FAQ           from './components/FAQ';
import Footer        from './components/Footer';
import EnquiryModal  from './components/EnquiryModal';
import WhatsAppFAB   from './components/WhatsAppFAB';

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [snack,     setSnack]     = useState(false);

  const openModal     = () => setModalOpen(true);
  const closeModal    = () => setModalOpen(false);
  const handleSuccess = () => { setSnack(true); closeModal(); };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Navbar onEnquire={openModal} />

      {/* pt = top-bar(33px) + navbar(80px) */}
      <Box component="main" sx={{ pt: '113px' }}>
        <HeroSlider onEnquire={openModal} />
<CityBoxes onEnquire={openModal} />
        <TrustBadges />
        <Testimonials />
        <FAQ />
        <Footer />
      </Box>

      <EnquiryModal open={modalOpen} onClose={closeModal} onSuccess={handleSuccess} />
      <WhatsAppFAB  onEnquire={openModal} />

      <Snackbar
        open={snack}
        autoHideDuration={4500}
        onClose={() => setSnack(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="success"
          sx={{ bgcolor: '#3d2200', color: '#ffe566', '& .MuiAlert-icon': { color: GOLD } }}
        >
          Thank you! Our advisor will call within 2 hours.
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
